import axios from '@axios'

const reportEndpointMap = {
    warehouse_stock_position_by_internal_grade: 'reports/warehouse_stock_position_by_internal_grade',
    warehouse_receiving_report: 'reports/warehouse_receiving_report',
    warehouse_dispatch_report: 'reports/warehouse_dispatch_report',
    warehouse_stack_grades: 'reports/warehouse_stack_grades',
    stacked_bales_by_date: 'reports/stacked_bales_by_date',
    warehouse_tf_movement_report: 'reports/warehouse_tf_movement_report',
}

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        locations: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('locations', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        warehouses: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('warehouse_names', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
         warehouses: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('warehouse_names', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        report: (cntx, params) => {
            const { reportType, ...requestParams } = params || {}
            const endpoint = reportEndpointMap[reportType] || reportEndpointMap.warehouse_stock_position_by_internal_grade
            console.log('WarehouseReports report fetch:', {
                endpoint,
                requestParams,
            })

            return new Promise((resolve, reject) => {
                axios.get(endpoint, { params: requestParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        getWarehouses: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.get('warehouses_min', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        gradesTransportation: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.get('reports/grades_transportation', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
    },
}
